// @ts-nocheck
import {Column} from 'react-table'
import {ApplicationsCustomHeader} from './ApplicationsCustomHeader'
import {ApplicationsName} from './ApplicationsName'
import {ApplicationsUrl} from './ApplicationsUrl'
import {ApplicationsDescription} from './ApplicationsDescription'
import {ApplicationsOrder} from './ApplicationsOrder'
import {ApplicationsActionsCell} from './ApplicationsActionsCell'
import {Applications} from '../../core/_models'

const ApplicationsColumns: ReadonlyArray<Column<Applications>> = [
  {
    Header: (props) => (
      <ApplicationsCustomHeader
        tableProps={props}
        title='APPLICATIONS.TABLE_TITLE'
        className='text-center min-w-125px'
      />
    ),
    id: 'title',
    Cell: ({...props}) => (
      <ApplicationsName applications={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <ApplicationsCustomHeader
        tableProps={props}
        title='APPLICATIONS.TABLE_URL'
        className='text-center min-w-400px'
      />
    ),
    id: 'url',
    Cell: ({...props}) => (
      <ApplicationsUrl applications={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <ApplicationsCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='text-center min-w-125px'
      />
    ),
    id: 'description',
    Cell: ({...props}) => (
      <ApplicationsDescription applications={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <ApplicationsCustomHeader
        tableProps={props}
        title='PROPERTY_REGISTRIES.ORDER'
        className='text-center min-w-125px'
      />
    ),
    id: 'order',
    Cell: ({...props}) => (
      <ApplicationsOrder applications={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <ApplicationsCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <ApplicationsActionsCell data={props.data[props.row.index]} />,
  },
]

export {ApplicationsColumns}
